import BaseView from '../base-view';

export default BaseView.extend({
	events: {
		'click': 'downloadErrorFile'
	},

	downloadErrorFile: function() {
		var data = this.el.getAttribute('data-errors').replace(/\|/g, '\r\n'),
			blob = new Blob([data], { type: 'text/plain' }),
			fileName = this.el.getAttribute('data-filename'),
			dummyLink, url;

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, fileName);
		} else {
			url = URL.createObjectURL(blob);
			dummyLink = document.createElement('a');

			dummyLink.href = url;
			dummyLink.download = fileName;

			document.body.appendChild(dummyLink);
			dummyLink.click();
		}
	}
});

